import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../common/Auth"
import BlogFeaturedSingle from "../../components/blog-featured/BlogFeaturedSingle";
import SectionTitle from "../../components/section-title/SectionTitle";
import { getFeaturedBlogs } from "../../redux/actions/blogActions"
import Loader from "../../common/Loader"

const BlogFeatured = ({ featuredBlogs, getFeaturedBlogs, loading }) => {

  const [blogSettings, setBlogSettings] = useState({})
  const { themeSettingsData } = useContext(AuthContext)



  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0) {
      themeSettingsData.map((i) => {
        if (i.settingsName === "blogSettings") {
          setBlogSettings(i.values[0])
        }
      })
    }
  }, [themeSettingsData])

  let mb = blogSettings.marginBottom ? blogSettings.marginBottom : "mb-0";
  let mt = blogSettings.marginTop ? blogSettings.marginTop : "mt-0";
  let ml = blogSettings.marginLeft ? blogSettings.marginLeft : "ml-0";
  let mr = blogSettings.marginRight ? blogSettings.marginRight : "mr-0";
  let pt = blogSettings.paddingTop ? blogSettings.paddingTop : "pt-0";
  let pb = blogSettings.paddingBottom ? blogSettings.paddingBottom : "pb-0";
  let pl = blogSettings.paddingLeft ? blogSettings.paddingLeft : "pl-0";
  let pr = blogSettings.paddingRight ? blogSettings.paddingRight : "pr-0";

  let fullSection = blogSettings.fullSection ? "container-fluid" : "container";
  let bgImage = blogSettings?.bgImage ? blogSettings?.bgImage : "";
  let bgColor = blogSettings?.bgColor ? blogSettings?.bgColor : "";


  useEffect(() => {
    getFeaturedBlogs(3, 0, "createdAt", "desc")
  }, [])
  if (!featuredBlogs || loading) {
    return <Loader />
  }
  return (
    <div
      className={`antera-blog-section-container blog-area section-bgImage ${mb} ${mt} ${mr} ${ml} ${pt} ${pb} ${pl} ${pr}`} 
      style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
    >
      <div className={`antera-blog-content-container ${fullSection}`}>
        <SectionTitle
          spaceClass="mb-55"
          titleText={blogSettings.sectionTitle ? blogSettings.sectionTitle : "OUR BLOG"}
        />
        <SectionTitle
          spaceClass="mb-55"
          subTitleText={blogSettings.sectionSubTitle ? blogSettings.sectionSubTitle : ""}
        />
        <div className="row">
          {featuredBlogs.length > 0 && featuredBlogs.map((singlePost, key) => {
            return (
              <BlogFeaturedSingle singlePost={singlePost} key={key} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

BlogFeatured.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};
const mapStateToProps = (state, ownProps) => {
  return {
    featuredBlogs: state.blogData.featuredBlogs,
    loading: state.blogData.loading,
    ownProps: ownProps,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getFeaturedBlogs: (limit, offset, order, orient, filter) => {
      dispatch(getFeaturedBlogs(limit, offset, order, orient, filter));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlogFeatured);
